module.exports = __webpack_public_path__ + "img/index-img-03.584efc21.png";